/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagevoidsome3Inputs */

const en_ticketpagevoidsome3 = /** @type {(inputs: Ticketpagevoidsome3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Void single tickets`)
};

const de_ticketpagevoidsome3 = /** @type {(inputs: Ticketpagevoidsome3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einzelne Tickets ungültig machen`)
};

/**
* | output |
* | --- |
* | "Void single tickets" |
*
* @param {Ticketpagevoidsome3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagevoidsome3 = /** @type {((inputs?: Ticketpagevoidsome3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagevoidsome3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagevoidsome3(inputs)
	return de_ticketpagevoidsome3(inputs)
});
export { ticketpagevoidsome3 as "ticketPageVoidSome" }